document.addEventListener("DOMContentLoaded", function() {

    function EqualHeight(elem) {
        const elements = document.querySelectorAll(`.${elem}`);
        let maxHeight = 0;
        elements.forEach((element) => {
            maxHeight = Math.max(maxHeight, element.offsetHeight);
        });
        elements.forEach((element) => {
            element.style.height = `${maxHeight}px`;
        });
    }

function sleep(ms = 50) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

function ensureCartDrawerIsHydrated() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return drawer;
    
    if (typeof drawer.open !== 'function') {
        try {
            if (typeof customElements !== 'undefined' && customElements.get('cart-drawer')) {
                const newDrawer = document.createElement('cart-drawer');
                newDrawer.innerHTML = drawer.innerHTML;
                newDrawer.className = drawer.className;
                newDrawer.id = drawer.id;
                drawer.parentNode.replaceChild(newDrawer, drawer);
                return newDrawer;
            }
        } catch (err) {
            console.warn('ensureCartDrawerIsHydrated: upgrade failed', err);
        }
    }
    return drawer;
}

function updateCartBubble(cartCount) {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon) return;
    
    let cartBubble = cartIcon.querySelector('.cart-count-bubble');
    
    if (cartCount > 0) {
        if (!cartBubble) {
            cartBubble = document.createElement('div');
            cartBubble.className = 'cart-count-bubble';
            cartIcon.appendChild(cartBubble);
        }
        
        cartBubble.innerHTML = `
            <span aria-hidden="true">${cartCount}</span>
            <span class="visually-hidden">
                ${cartCount} item${cartCount !== 1 ? 's' : ''}
            </span>
        `;
        cartBubble.style.display = 'block';
        
        try {
            const cartDrawerWrapper = document.querySelector('cart-drawer');
            if (cartDrawerWrapper) {
                cartDrawerWrapper.classList.toggle('is-empty', cartCount === 0);
            }
            
            const mainCartFooter = document.getElementById('main-cart-footer');
            if (mainCartFooter) {
                mainCartFooter.classList.toggle('is-empty', cartCount === 0);
            }
        } catch (err) {
            console.warn('updateCartBubble: safe toggle failed', err);
        }
    } else if (cartBubble) {
        cartBubble.style.display = 'none';
    }
}


function forceDrawerStateSync(drawer, itemCount) {
    if (!drawer) return;

    drawer.classList.remove('is-empty', 'active', 'animate');
    document.body.classList.remove('overflow-hidden');

    if (itemCount === 0) {
        drawer.classList.add('is-empty');
        return;
    }

    drawer.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');
}



function manuallyOpenDrawer(drawer) {
    if (!drawer) return;
    

    const cartDrawerNote = drawer.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
        cartDrawerNote.setAttribute('role', 'button');
        cartDrawerNote.setAttribute('aria-expanded', 'false');
        if (cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.id) {
            cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
        }
    }
    
    setTimeout(() => {
        drawer.classList.add('active');
    }, 10);
    

    const container = drawer.classList.contains('is-empty') 
        ? drawer.querySelector('.drawer__inner-empty') 
        : document.getElementById('CartDrawer');
    
    const focusElement = drawer.querySelector('.drawer__inner') || drawer.querySelector('.drawer__close');
    
    if (container && focusElement && typeof trapFocus === 'function') {
        trapFocus(container, focusElement);
    }
    
    document.body.classList.add('overflow-hidden');
}

function safeOpenDrawer(drawer, itemCount = null) {
    if (!drawer) return false;

    drawer.classList.remove('is-empty', 'active', 'animate');
    drawer.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');

    if (itemCount !== null) {
        forceDrawerStateSync(drawer, itemCount);
    }

    try {
        if (typeof drawer.open === 'function') {
            const cartLink = document.querySelector('#cart-icon-bubble');
            drawer.open(cartLink);
            return true;
        } else {
            manuallyOpenDrawer(drawer);
            return true;
        }
    } catch (err) {
        console.error('drawer.open threw:', err);
        manuallyOpenDrawer(drawer);
        return true;
    }
}


async function updateCartDrawerAndOpen() {
    try {
        const cartData = await fetch('/cart.js').then(r => r.json());
        const itemCount = cartData.item_count;

        const html = await fetch('/cart?section_id=cart-drawer').then(r => r.text());
        const newHTML = new DOMParser().parseFromString(html, 'text/html');

        const oldDrawer = document.querySelector('cart-drawer');
        const newDrawer = newHTML.querySelector('cart-drawer');

        if (oldDrawer && newDrawer) {
            oldDrawer.innerHTML = newDrawer.innerHTML;

 
            oldDrawer.classList.remove('is-empty', 'active', 'animate');
            document.body.classList.remove('overflow-hidden');

   
            forceDrawerStateSync(oldDrawer, itemCount);

            await sleep(50);
            ensureCartDrawerIsHydrated();
            reinitializeCartDrawer();

            await sleep(50);
            safeOpenDrawer(oldDrawer, itemCount);
        }

        updateCartBubble(itemCount);
    } catch (err) {
        console.error(err);
    }
}



async function updateCartDrawerFallback(shouldOpen = false, itemCount = null) {
    try {
        if (itemCount === null) {
            const cartData = await fetch('/cart.js').then(r => r.json());
            itemCount = cartData.item_count;
        }
        
        const response = await fetch('/cart?view=drawer');
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        
        const text = await response.text();
        const newDrawerHTML = new DOMParser().parseFromString(text, 'text/html');
        const newCartDrawerComponent = newDrawerHTML.querySelector('cart-drawer');
        const currentCartDrawerComponent = document.querySelector('cart-drawer');
        
        if (newCartDrawerComponent && currentCartDrawerComponent) {
            currentCartDrawerComponent.replaceWith(newCartDrawerComponent);
            const drawer = document.querySelector('cart-drawer');
            
            if (drawer) {
                forceDrawerStateSync(drawer, itemCount);
                ensureCartDrawerIsHydrated();
                await sleep(100);
                reinitializeCartDrawer();
                
                if (shouldOpen) {
                    await sleep(50);
                    safeOpenDrawer(drawer, itemCount);
                }
            }
        }
    } catch (error) {
        console.error('Fallback cart drawer update failed:', error);
    }
}


async function updateCartDrawer() {
    try {
        const cartData = await fetch('/cart.js').then(r => r.json());
        const itemCount = cartData.item_count;
        const response = await fetch('/cart?section_id=cart-drawer');
        
        if (!response.ok) {
            await updateCartDrawerFallback(false, itemCount);
            return;
        }
        
        const text = await response.text();
        const newCartDrawerComponent = new DOMParser().parseFromString(text, 'text/html').querySelector('cart-drawer');
        const currentCartDrawerComponent = document.querySelector('cart-drawer');
        
        if (newCartDrawerComponent && currentCartDrawerComponent) {
            currentCartDrawerComponent.replaceWith(newCartDrawerComponent);
            const drawer = document.querySelector('cart-drawer');
            
            if (drawer) {
                forceDrawerStateSync(drawer, itemCount);
                ensureCartDrawerIsHydrated();
                await sleep(80);
                reinitializeCartDrawer();
            }
        }
    } catch (error) {
        console.error('Error updating cart drawer:', error);
        await updateCartDrawerFallback();
    }
}


window.addToCartWithProperties = async function(variantId, properties = {}, quantity = 1) {
    try {
        const formData = {
            items: [{
                id: variantId,
                quantity: quantity,
                properties: properties
            }],
        };
        
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData),
        });
        
        const result = await response.json();
        
        if (!response.ok) {
            console.error('Add to cart failed:', result);
            return;
        }
        
        const cartData = await fetch('/cart.js').then((r) => r.json());
        updateCartBubble(cartData.item_count);
        await updateCartDrawerAndOpen();
    } catch (error) {
        console.error('Error adding to cart:', error);
    }
};


document.addEventListener('click', async (e) => {
    const button = e.target.closest('.cart-item-remove');
    if (!button) return;
    
    const line = Number(button.dataset.line);
    button.disabled = true;
    const prevText = button.textContent;
    button.textContent = 'Removing...';
    
    try {
        await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                line: line,
                quantity: 0
            }),
        });
        
        const cartData = await fetch('/cart.js').then((r) => r.json());
        await updateCartDrawer();
        updateCartBubble(cartData.item_count);
        
        if (cartData.item_count === 0) {
            const drawer = document.querySelector('cart-drawer');
            if (drawer) {
                if (typeof drawer.close === 'function') {
                    try {
                        drawer.close();
                    } catch (err) {
                        console.warn('drawer.close threw:', err);
                        drawer.classList.remove('active');
                        document.body.classList.remove('overflow-hidden');
                    }
                } else {
                    drawer.classList.remove('active');
                    document.body.classList.remove('overflow-hidden');
                }
            }
        }
    } catch (err) {
        console.error('Remove failed:', err);
        button.disabled = false;
        button.textContent = prevText || 'Remove';
    }
});


document.addEventListener('change', async (e) => {
    if (!e.target.classList.contains('quantity__input')) return;
    
    const input = e.target;
    const form = input.closest('form');
    
    try {
        const formData = new FormData(form);
        await fetch('/cart/update.js', {
            method: 'POST',
            body: formData,
        });
        
        await updateCartDrawer();
        const cartData = await fetch('/cart.js').then((r) => r.json());
        updateCartBubble(cartData.item_count);
    } catch (err) {
        console.error('Quantity update failed:', err);
    }
});

document.addEventListener('click', (e) => {
    if (e.target.matches('#CartDrawer-Overlay') || e.target.closest('#CartDrawer-Overlay')) {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer) return;
        
        if (typeof drawer.close === 'function') {
            try {
                drawer.close();
            } catch (err) {
                console.warn('drawer.close threw on overlay click:', err);
                drawer.classList.remove('active');
                document.body.classList.remove('overflow-hidden');
            }
        } else {
            drawer.classList.remove('active');
            document.body.classList.remove('overflow-hidden');
        }
    }
});


function reinitializeCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    
    // Reinitialize cart link
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink && !cartLink.hasAttribute('data-cart-reinitialized')) {
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        
        const handler = (event) => {
            event.preventDefault();
            const drawerEl = document.querySelector('cart-drawer');
            if (!drawerEl) return;
            
            fetch('/cart.js')
                .then((r) => r.json())
                .then((cartData) => {
                    forceDrawerStateSync(drawerEl, cartData.item_count);
                    safeOpenDrawer(drawerEl, cartData.item_count);
                })
                .catch((err) => {
                    console.error('Error checking cart state:', err);
                    safeOpenDrawer(drawerEl);
                });
        };
        
        cartLink.replaceWith(cartLink.cloneNode(true));
        const newCartLink = document.querySelector('#cart-icon-bubble');
        
        newCartLink.addEventListener('click', handler);
        newCartLink.addEventListener('keydown', (ev) => {
            if (ev.code === 'SPACE') {
                ev.preventDefault();
                handler(ev);
            }
        });
        
        newCartLink.setAttribute('data-cart-reinitialized', 'true');
    }
    
    // Reinitialize escape key handler
    if (drawer && !drawer.hasAttribute('data-escape-reinitialized')) {
        drawer.addEventListener('keyup', (evt) => {
            if (evt.code === 'Escape') {
                if (typeof drawer.close === 'function') {
                    try {
                        drawer.close();
                    } catch (err) {
                        console.warn('drawer.close on escape threw:', err);
                        drawer.classList.remove('active');
                        document.body.classList.remove('overflow-hidden');
                    }
                } else {
                    drawer.classList.remove('active');
                    document.body.classList.remove('overflow-hidden');
                }
            }
        });
        drawer.setAttribute('data-escape-reinitialized', 'true');
    }
}


ensureCartDrawerIsHydrated();
reinitializeCartDrawer();

setTimeout(() => {
    ensureCartDrawerIsHydrated();
    reinitializeCartDrawer();
}, 500);

const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1 && node.matches && node.matches('cart-drawer')) {
                    setTimeout(() => {
                        ensureCartDrawerIsHydrated();
                        reinitializeCartDrawer();
                    }, 100);
                }
            });
        }
    });
});

observer.observe(document.body, { childList: true, subtree: true });

    const intro = document.querySelector(".intro");
    if (intro) {
        setTimeout(() => {
            intro.classList.add("hide");
        }, 1000);
    }


    // document.querySelectorAll(".essential_wrap .right").forEach((rightBlock) => {
    //     const slider1El = rightBlock.querySelector(".essential_slider");
    //     const slider2El = rightBlock.querySelector(".essential_slider_2");
    //     const mobileSilderEl = document.querySelectorAll(".essential_card");
    //     if (window.innerWidth <= 800) {
    //         mobileSilderEl?.forEach((mobileRightBlock) => {
    //             const slider3El = mobileRightBlock.querySelector(".right .essential_slider");
    //             const slider3 = new Swiper(slider3El, {
    //                 loop: true,
    //                 slidesPerView: 1,
    //                 spaceBetween: 40,
    //                 allowTouchMove: true,
    //                 navigation: {
    //                     nextEl: slider3El.querySelector(".essential_slider_arrow_right"),
    //                     prevEl: slider3El.querySelector(".essential_slider_arrow_left"),
    //                 },
    //                 breakpoints: {
    //                     600: { slidesPerView: 2 },
    //                     1000: { slidesPerView: 1, allowTouchMove: false },
    //                 },
    //             });
    //         });
    //     }
    //     if (slider1El && slider2El) {
    //         let isFirstInit = true;
    //         const slider1 = new Swiper(slider1El, {
    //             loop: true,
    //             slidesPerView: 1,
    //             spaceBetween: 40,
    //             allowTouchMove: true,
    //             breakpoints: {
    //                 850: { slidesPerView: 2 },
    //                 1000: { slidesPerView: 1, allowTouchMove: false },
    //             },
    //         });
    //         const slider2 = new Swiper(slider2El, {
    //             loop: true,
    //             slidesPerView: 1,
    //             slidesPerGroup: 1,
    //             spaceBetween: 40,
    //             initialSlide: 1,
    //             // autoplay: { delay: 3000, disableOnInteraction: true },
    //             navigation: {
    //                 nextEl: rightBlock.querySelector(".essential_slider_arrow_right"),
    //                 prevEl: rightBlock.querySelector(".essential_slider_arrow_left"),
    //             },
    //             on: {
    //                 init: function() {
    //                     setTimeout(() => {
    //                         isFirstInit = false;
    //                     }, 100);
    //                 },
    //                 slideNextTransitionStart: function() {
    //                     if (isFirstInit) return;
    //                     slider1.slideNext();
    //                 },
    //                 slidePrevTransitionStart: function() {
    //                     if (isFirstInit) return;
    //                     slider1.slidePrev();
    //                 },
    //             },
    //             breakpoints: {
    //                 1440: { slidesPerView: 1.5 },
    //                 1920: { slidesPerView: 2.2 },
    //             },
    //         });
    //     }
    // });

    // const categories = document.querySelectorAll(".left .essential_card");
    // categories.forEach((category) => {
    //     category.addEventListener("click", () => {
    //         categories.forEach((cat) => {
    //             cat.classList.remove("active");
    //             const icon = cat.querySelector(".toggle-icon");
    //             if (icon) {
    //                 icon.src = "https://cdn.shopify.com/s/files/1/0697/1015/1902/files/add_icon_b5ceb079-29fe-4590-8c59-87fc1887b0b3.png?v=1757581151";
    //                 icon.alt = "expand";
    //             }
    //         });
    //         category.classList.add("active");
    //         const activeIcon = category.querySelector(".toggle-icon");
    //         if (activeIcon) {
    //             activeIcon.src = "https://cdn.shopify.com/s/files/1/0697/1015/1902/files/dakshin-minus.svg?v=1763549243";
    //             activeIcon.alt = "collapse";
    //         }
    //     });
    // });

    // const defaultActive = document.querySelector(".left .essential_card.active");
    // if (defaultActive) {
    //     const icon = defaultActive.querySelector(".toggle-icon");
    //     if (icon) {
    //         icon.src = "https://cdn.shopify.com/s/files/1/0697/1015/1902/files/dakshin-minus.svg?v=1763549243";
    //         icon.alt = "collapse";
    //     }
    // }


});